/** Keep in sync with PredefinedOptionListConstants (ntcog-api). */
export const PREDEFINED_OPTION_LIST_CODES = [
  "DISTRICT_CHURCHES",
  "NATION_CHURCHES",
  "NATION_DISTRICTS",
  "DEPARTMENTS",
] as const;
export type PredefinedOptionListCode = (typeof PREDEFINED_OPTION_LIST_CODES)[number];

export type PredefinedOptionList = {
  predefined_option_list_code: PredefinedOptionListCode | string;
  name: string;
  description?: string | null;
  scope_type?: string | null;
  is_active: boolean;
  /** Which template levels can fill the list. */
  level_hint: string;
};

export type PredefinedOptionListEntry = {
  id: number;
  name: string;
  is_active: boolean;
};

export type PredefinedOptionListPreview = PredefinedOptionList & {
  /** District or nation the preview was filled from (null for context-free lists). */
  context_name?: string | null;
  entries: PredefinedOptionListEntry[];
};

export type PredefinedOptionListResponse = { data: PredefinedOptionList[] };
export type PredefinedOptionListPreviewResponse = { data: PredefinedOptionListPreview };

/** Typed options vs a predefined list. */
export type OptionSource = "TYPED" | "LIST";

/** Inactive entries go last; order within each group is kept. */
export function sortEntriesInactiveLast<T extends { is_active?: boolean }>(entries: T[]): T[] {
  return [
    ...entries.filter((e) => e.is_active !== false),
    ...entries.filter((e) => e.is_active === false),
  ];
}
